module.exports = __webpack_public_path__ + "static/img/weather46.5e446a54.png";